import createLogger from 'redux-logger';
import ENV from '../../env';

const logger = ENV.PUSHBOT_VERBOSE
  ? createLogger({
      level: ENV.PUSHBOT_LOG_LEVEL,
      collapsed: true
    })
  : store => next => action => next(action); // eslint-disable-line no-unused-vars

export default logger;



// WEBPACK FOOTER //
// ./js/store/config/logger.js